import { EventDto } from './event.dto';
import { UserDto } from './user.dto';
import { EventPriceDto } from './event-price.dto';
import { GetUserOrUpsertTempUser } from './auth.dto';
import { IsOptional, IsString, IsUUID } from 'class-validator';

export class JoinWaitlistDto {
	@IsOptional()
	@IsString()
	@IsUUID()
	baseEventPriceId?: string;
}

export class JoinWaitlistPublicDto extends GetUserOrUpsertTempUser implements JoinWaitlistDto {
	@IsOptional()
	@IsString()
	@IsUUID()
	baseEventPriceId?: string;
}

export class WaitlistedUserToEventDto {
	public id: string;
	public userId: string;
	public eventId: string;
	public baseEventPriceId: string;
	public eventInstanceDate: Date;
	public initialEventInstanceDate: Date;
	public isSpotAvailable: boolean;
	public createdAt: Date;
	public updatedAt: Date;
	public deletedAt?: Date;

	public user?: UserDto;
	public event?: EventDto;
	public baseEventPrice?: EventPriceDto;
}
